module.exports = {
  REGEX_TIERS_NAMES: ['BRONZE', 'SILVER', 'GOLD', 'PLATINUM'],
  LOYALTY_HEADERS: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  LOYALTY_DETAILS_LINK: 'https://customerservice-macys.com/articles/macys-star-rewards-terms-conditions',
};
